export default __webpack_public_path__ + "static/PCB-f84ff7c0fb899a3c4d447f7e8073087a.png";